<template>
    <section class="wrap">
        <a href="https://game.naver.com/lounge/samgukji_origin2/home" class="btn-link"></a>
        <div class="content">
            <div class="login-box" v-if="showDialog.login">
                <a href="javascript:;" class="btn-gp" @click="openLogin(8, 'com.r2.sgmnz.kr')"></a>
                <a href="javascript:;" class="btn-ios" @click="openLogin(9, 'com.r2.zqwz.kr')"></a>
                <a href="javascript:;" class="btn-fb" @click="openLogin(2, 'com.r2.sgmnz.kr')"></a>
                <a href="javascript:;" class="btn-visitor" @click="showTips"></a>
            </div>
            <div class="reward-box" v-if="showDialog.redeem">
                <a href="javascript:;" class="btn-redeem" @click="redeemCode"></a>
                <p class="rules"></p>
                <a href="javascript:;" class="btn-logout" @click="logOut"></a>
            </div>
            <div class="text rules">
                <h3>참여 방법</h3>
                <p>&lt;삼국지 오리진&gt; 게임 계정으로 로그인하여 유저 인증에 성공하면 즉시 &lt;삼국지 오리진2: 적벽대전&gt;의 쿠폰번호를 획득할 수 있습니다. </p>
                <p>&nbsp;</p>
                <h3>주의 사항</h3>
                <p>1. &lt;삼국지 오리진&gt; 유저만이 본 이벤트에 참여 가능합니다. 문의가 있으면 &lt;삼국지 오리진2: 적벽대전&gt; 고객센터 메일 grgames@guru-game.com로 연락주시기 바랍니다.</p>
                <p>2. 페이스북 계정 접속-로그아웃-재접속을 진행하면 자동 해당 같은 페북 계정으로 접속만 가능하며 다른 페북 계정으로 접속할 수 없습니다. 해당 경우 인터넷 사용 기록(쿠키 및 데이터 등) 삭제하여 페이지 새로고침 후 다른 페북 계정으로 접속 가능합니다.</p>
                <p>3. 해당 쿠폰번호는 영구 유효이며 &lt;삼국지 오리진2: 적벽대전&gt;에서만 사용 가능합니다. 또한 1회에 한하여 사용 가능하기에 다른 분들에게 공유하지 마십시오. 쿠폰번호를 사용하지 못할 경우 &lt;삼국지 오리진2: 적벽대전&gt; 게임내 고객센터로 연락주시기 바랍니다.</p>
            </div>
            <footer class="footer" style="display: none;">Copyright © GURU GAMES CO., LIMITED. All Rights Reserved.</footer>

            <div class="popup-box" v-if="showDialog.dialog">
                <div class="inner">
                    <a href="javascript:;" class="btn-close" @click="showDialog.dialog = false"></a>
                    <div class="code-box">
                        <input type="text" v-model="code">
                        <a href="javascript:;" class="btn-copy" @click="copy"></a>
                    </div>
                </div>
            </div>

            <div v-if="showDialog.alert === true" class="popup-box popup-alert">
                <div class="inner">
                    <a href="javascript:;" class="btn-close" @click="showDialog.alert = false"></a>
                    <div class="text flex justify-center items-center">
                        <div>{{ showDialog.alertMsg }}</div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
  
  
<script>
import { redeemCodeApi } from "@/api/api";
export default {
    components: {},
    name: "rewards",
    data() {
        return {
            showDialog: {
                login: false,
                redeem: false,
                dialog: false,
                alert: false,
                alertMsg: ''
            },
            code: '',
            redeeming: false,
            formData: {
                gameId: 489,
                appId: '497cce5311a52f2a5f14c93c9a2a06af',
                user: '',
                time: '',
                vSign: '',
                sign: 1
            }
        };
    },
    created() {
        const rid = this.$route.query.rid;
        if (rid) {
            this.showDialog.redeem = true;
            this.formData.user = rid;
            this.formData.time = this.$route.query.timestamp;
            this.formData.vSign = this.$route.query.vSign;

            this.save('origin2_pre_rid', this.$route.query.rid);
            this.save('origin2_pre_timestamp', this.$route.query.timestamp);
            this.save('origin2_pre_vSign', this.$route.query.vSign);

            this.$router.push({
                path: '/mobile/origin1rewards/',
                query: null
            })
        } else {
            this.formData.user = this.fetch('origin2_pre_rid');
            if(this.formData.user){
                this.showDialog.redeem = true;
                this.formData.time = this.fetch('origin2_pre_timestamp');
                this.formData.vSign = this.fetch('origin2_pre_vSign');
            } else {
                this.showDialog.login = true;
            }
        }
        if(this.$route.query.message){
            this.showDialog.alert = true;
            this.showDialog.alertMsg = this.$route.query.message;
        }
    },
    mounted() {
        window.addEventListener('resize', () => {
            window.location.reload()
        }, 300);
    },
    methods: {
        logOut(){
            this.showDialog.redeem = false;
            this.showDialog.login = true;
            this.formData.user = '';
            this.formData.time = '';
            this.formData.vSign = '';
            window.localStorage.clear();
        },
        fetch(key) {
            return window.localStorage.getItem(key) || ''
        },
        save(key, items){
            if(items){
                window.localStorage.setItem(key, items.toString())
            }
        },
        copy(){
            navigator.clipboard.writeText(this.code).then(() => {
                alert("교환 코드를 복사하였습니다.")
            });
        },
        openLogin(type, pkgName) {
            window.location.href = `https://gateway.r2game.com/?service=enplatWebPay&api=login&gameId=489&appId=66a59ddde1266a9e155149ecb7aff737&type=${type}&pkgName=${pkgName}&backUrl=https://www.guru-game.com/origin2/mobile/origin1rewards/`  // type: 9 ios, 8 googlePlay, 2 facebook
        },
        redeemCode() {
            if (this.code) {
                this.showDialog.dialog = true;
                return
            }
            if (this.redeeming) return;
            this.redeeming = true;
            setTimeout(() => {
                this.redeeming = false
            }, 1000)
            redeemCodeApi(this.formData).then((data) => {
                if (data.code === 0) {
                    this.showDialog.dialog = true;
                    this.code = data.data;
                    if(data.data === '领完'){
                        this.code = '재고 부족';
                    }
                } else {
                    this.showDialog.alert = true;
                    this.showDialog.alertMsg = '';
                    this.showDialog.alertMsg = data.message;
                }
            });
        },
        showTips() {
            this.showDialog.alert = true;
            this.showDialog.alertMsg = '';
            this.showDialog.alertMsg = '게스트 계정을 통해 <삼국지 오리진>을 이용한 경우, 로그인이 불가하며 <삼국지 오리진> 게임 앱에서 계정 연동 후 다시 로그인하시기 바랍니다.';
        }
    },
};
</script>
  
<style lang="less" scoped>
.wrap {
    height: 1954rem;
    background: url("../../assets/rewards/mobile/bg.jpg") no-repeat center;
    background-size: 100% 100%;

    .login-box {
        height: 1250rem;
        margin: 0 auto;
        padding-top: 800rem;

        .btn-ios,
        .btn-gp,
        .btn-fb,
        .btn-visitor {
            display: block;
            width: 500rem;
            height: 96rem;
            margin: 0 auto 16rem;
            background-repeat: no-repeat;
            background-position: center;
        }

        .btn-ios {
            background-image: url("../../assets/rewards/mobile/btn_ios.png");
            background-size: 100% 100%;
        }

        .btn-gp {
            background-image: url("../../assets/rewards/mobile/btn_gp.png");
            background-size: 100% 100%;
        }

        .btn-fb {
            background-image: url("../../assets/rewards/mobile/btn_fb.png");
            background-size: 100% 100%;
        }

        .btn-visitor {
            background-image: url("../../assets/rewards/mobile/btn_visitor.png");
            background-size: 100% 100%;
        }
    }
    .text{
        margin: 0 auto;
        color: #a1a1a1;
        font-size: 20rem;
        h3{
            font-size: 22rem;
            font-weight: bold;
        }
    }
    .rules{
        width: 680rem;
    }

    .reward-box {
        height: 1200rem;
        padding-top: 800rem;

        .btn-redeem {
            display: block;
            width: 700rem;
            height: 142rem;
            margin: 0 auto;
            background: url("../../assets/rewards/mobile/btn_redeem.png") no-repeat center;
            background-size: 100% 100%;
        }

        .rules {
            width: 510rem;
            height: 105rem;
            margin: 28rem auto;
            background: url("../../assets/rewards/mobile/rules.png") no-repeat center;
            background-size: 100% 100%;
        }
        .btn-logout{
            display: block;
            width: 340rem;
            height: 84rem;
            margin: 0 auto;
            background: url("../../assets/rewards/mobile/logout.png") no-repeat center;
            background-size: 100% 100%;
        }
    }

    .btn-link {
        position: absolute;
        top: 20rem;
        right: 18rem;
        z-index: 10;
        width: 50rem;
        height: 50rem;
    }

    // 弹窗
    .popup-box {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 998;
        width: 100%;
        background: rgba(0, 0, 0, .8);

        .inner {
            position: absolute;
            left: 50%;
            top: 50%;
            z-index: 999;
            width: 606rem;
            height: 640rem;
            margin-left: -303rem;
            margin-top: -320rem;
            background-repeat: no-repeat;
            background-size: 100% auto;
            background-image: url("../../assets/rewards/mobile/popup_bg.jpg");
            background-size: 100% 100%;
        }

        .btn-close {
            position: absolute;
            top: 22rem;
            right: 16rem;
            z-index: 1000;
            width: 50rem;
            height: 50rem;
            margin-left: 0;
            background: url("../../assets/rewards/mobile/btn_close.png") no-repeat center;
            background-size: 100% 100%;
        }

        .code-box {
            position: relative;
            height: 64rem;
            margin-top: 146rem;
            font-size: 35rem;
            font-weight: bold;
            line-height: 64rem;
            input{
                width: 338rem;
                margin-left: 135rem;
                background: transparent;
                color: #fff;
                text-align: center;
            }
            .btn-copy{
                position: absolute;
                top: 15rem;
                right: 26rem;
                z-index: 10;
                width: 60rem;
                height: 40rem;
                background: url("../../assets/rewards/mobile/btn_copy.png") no-repeat center;
                background-size: 100% 100%;

            }
        }

        &.popup-alert {
            .inner {
                height: 266rem;
                margin-top: -133rem;
                background-image: url(../../assets/images/mobile/pop_s.jpg);
                background-size: 100% 100%;
                color: #fff;
                font-size: 26rem;
            }

            .text {
                height: 100%;
                padding: 0 30rem;
            }
        }
    }

}
</style>
    